import React, { useState, useEffect } from "react";
import { getOrganizationUsers } from "../../controllers/OrganizationController";
import "./SelectedOrganization.css";

function OrganizationUsersList({ id }) {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        getOrganizationUsers(id)
            .then((data) => {
                setUsers(data || []);
            })
            .catch((error) => {
                console.error("Error fetching organization users:", error);
                setUsers([]);
            });
    }, [id]);

    return (
        <div className="UsersList">
            <h3>Liste des membres</h3>
            <ul>
                {users.length > 0 ? (
                    users.map((user, index) => (
                        <li key={index}>
                            <p>{user.username}</p>
                        </li>
                    ))
                ) : (
                    <li>Aucun membre</li>
                )}
            </ul>
        </div>
    );
}

export default OrganizationUsersList;
